import { StyleSheet } from 'react-native';
import { heightPercentageToDP as hp } from 'react-native-responsive-screen';

export const styles = StyleSheet.create({
  cardOrderItem: {
    backgroundColor: '#011c47',
    marginBottom: 10,
    width: '90%',
    alignSelf: 'center',
    padding: 10,
    borderRadius: 5,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-evenly',
  },
  cardOrderColumn: {
    flex: 1,
    isplay: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  clothingSizeStocksContainer: {
    flex: 1,
  },
  clothingSizeStockGroupContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-evenly',
  },
  textOrderIdLarge: {
    marginLeft: 15,
    fontSize: 16,
    fontWeight: '500',
    textAlign: 'center',
    lineHeight: 24,
    letterSpacing: 0,
    color: '#FFFFFF',
  },
  textOrderIdSmall: {
    fontSize: 14,
    fontWeight: '400',
    textAlign: 'center',
    lineHeight: 16,
    letterSpacing: 0,
    color: '#FFFFFF',
  },
  cardOrderItemLarge: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    alignSelf: 'center',
    alignItems: 'center',
    paddingVertical: 15,
    paddingHorizontal: 20,
    height: hp('50%'),
    width: '90%',
    backgroundColor: '#001C47',
    borderRadius: 5,
    marginBottom: 10,
  },
  cardOrderItemSmall: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    alignSelf: 'center',
    alignItems: 'center',
    paddingVertical: 8,
    paddingRight: 24,
    paddingLeft: 16,
    height: hp('60%'),
    width: '90%',
    backgroundColor: '#001C47',
    borderRadius: 5,
    marginBottom: 10,
  },
  iconDefault: {
    marginTop: 2,
    alignSelf: 'center',
    color: '#0F6657',
  },
  containerIcon: {
    backgroundColor: '#fff',
    borderRadius: 15,
    width: 35,
    height: 35,
  },
});
